import { render } from "./RowsLayout.vue?vue&type=template&id=a641177e&scoped=true"
import script from "./RowsLayout.vue?vue&type=script&lang=js"
export * from "./RowsLayout.vue?vue&type=script&lang=js"

import "./RowsLayout.vue?vue&type=style&index=0&id=a641177e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a641177e"]])

export default __exports__